export const PublishAsGeneratedPdfTitle = "Genererad PDF";
export const PublishAsOriginalTitle = "Original";

const pdfConvertibleFileTypes = new Set([
  "word",
  "doc",
  "docx",
  "powerpoint",
  "ppt",
  "pptx",
  "excel",
  "xls",
  "xlsx",
]);

export const canPublishAsGeneratedPdf = (
  fileNameOrUrl?: string | null,
  fileType?: string | null
): boolean => {
  const value = `${fileNameOrUrl ?? ""} ${fileType ?? ""}`.toLowerCase();

  if (
    value.includes(".pdf") ||
    value.includes("application/pdf") ||
    value.trim() === "pdf"
  ) {
    return false;
  }

  return Array.from(pdfConvertibleFileTypes).some((candidate) =>
    value.includes(candidate)
  );
};

export const normalizePublishAsGeneratedPdfValue = (
  publishAsGeneratedPdf: boolean | undefined,
  fileNameOrUrl?: string | null,
  fileType?: string | null
): boolean =>
  publishAsGeneratedPdf === true &&
  canPublishAsGeneratedPdf(fileNameOrUrl, fileType);

export const getPublishAsGeneratedPdfDisplayValue = (
  publishAsGeneratedPdf?: boolean | null
): string =>
  publishAsGeneratedPdf === true
    ? PublishAsGeneratedPdfTitle
    : PublishAsOriginalTitle;
